<template>
  <div>
    <div v-if="internalColor === 'regenbogen'" class="color-tile rainbow" />
    <div v-else-if="internalColor === 'farbspiel1'" class="color-tile farbspiel-1" />
    <div v-else-if="internalColor === 'farbspiel2'" class="color-tile farbspiel-2" />
    <div v-else-if="internalColor === 'farbspiel3'" class="color-tile farbspiel-3" />
    <div v-else-if="internalColor === 'farbspiel4'" class="color-tile farbspiel-4" />
    <div v-else class="color-tile" :style="{ backgroundColor: internalColor }" />
  </div>
</template>

<script>
export default {
  name: "ColorTile",
  props: {
    color: { type: String, default: "" }
  },
  data() {
    return {
      internalColor: ""
    };
  },
  mounted() {
    switch (this.color) {
      case "rot":
        this.internalColor = "#e63232";
        break;
      case "grün":
        this.internalColor = "#8cc83c";
        break;
      case "blau":
        this.internalColor = "#14b4f0";
        break;
      case "weiß":
        this.internalColor = "#e6e6e6";
        break;
      case "gelb":
        this.internalColor = "#f0dc1e";
        break;
      case "orange":
        this.internalColor = "#ffa500";
        break;
      case "magenta":
        this.internalColor = "#FF00FF";
        break;
      case "cyan":
        this.internalColor = "#00FFFF";
        break;
      case "Regenbogen":
        this.internalColor = "regenbogen";
        break;
      case "cyan-magenta-gelb":
        this.internalColor = "farbspiel1";
        break;
      case "blau-weiß":
        this.internalColor = "farbspiel2";
        break;
      case "gelb-rot":
        this.internalColor = "farbspiel3";
        break;
      case "cyan-magenta":
        this.internalColor = "farbspiel4";
        break;
    }
  }
};
</script>

<style scoped>
.color-tile {
  width: 80px;
  min-height: 120px;
  margin-bottom: -40px;
}
</style>
